// 【 持久化存储的仓库 】模块
const persistedStateStore = {
  state: {
    // 是否同时具有 多版本报告权限 和 已应用报告权限
    isHasAndUseMultiReportVersion: null,
  },
  getters: {
    getIsHasAndUseMultiReportVersion(state) {
      return state.isHasAndUseMultiReportVersion
    },
  },
  mutations: {
    setIsHasAndUseMultiReportVersion(state, config) {
      console.log('config', config)
      state.isHasAndUseMultiReportVersion = config
    },
  },
}
export default persistedStateStore
